import {DIRECTION} from '../free_play_component_consts';

export const ScrollingContainerStyle = {
    MOBILE: {
        [DIRECTION.HORIZONTAL]: {
            arrowsPadding: [10, 30, 20, 30],
            itemGap: 15, //10
            //scrollingStep: 4,
            // isCenterItems: true,
            // grid: {
            //     itemsInRow: 1, gap: 0
            // }
        },
        [DIRECTION.VERTICAL]: {
            arrowsPadding: [10, 10, 10, 10],
            itemGap: 10,
            // isCenterItems: false,
            // scrollingStep: 2,
            // grid: {
            //     itemsInRow: 2, gap: 30
            // }
        }
    },
    PC: {
        [DIRECTION.HORIZONTAL]: {
            arrowsPadding: [10, 30, 20, 30],
            itemGap: 15,
           // scrollingStep: 4
        },
        [DIRECTION.VERTICAL]: {
            arrowsPadding: [5, 0, 20, 0],
            itemGap: 15,
            externalScroll: false,
            isArrowVisible: false,
            //scrollingStep: 2,
            // isCenterItems: false,
            // grid: {
            //     itemsInRow: 2, gap: 30
            // }
        }
    }
}

export const FP_GAME_ITEM_CLASSES = {
    GAME_ITEM_FP_TYPE_THUMB: 'cgp-game-item-fp-thumb',
    GAME_ITEM_FP: 'cgp-game-item-fp'
}

export const FP_GAMES_CONTAINER_CLASS = 'cgp-fp-games-container';

export const FP_GAMES_SHOW_MORE_CLASS = 'cgp-fp-games-more-less-btn';

export const FP_GAMES_COMPONENT_LIMIT = 6;
